import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-increment-posting-form',
  templateUrl: './increment-posting-form.component.html',
  styleUrls: ['./increment-posting-form.component.css']
})
export class IncrementPostingFormComponent implements OnInit {

  title="Add Increment Post";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Increments/increment-posting/increment-posting-form/increment-posting-form.component.ts